import { Toggle } from '@warp-ds/react/components/toggle';
import type { FilterProps } from '../../Filter';

const houseRulesList = [
    { name: 'Rullestolvennlig', id: 'wheelchairAccessible' },
    { name: 'Kjæledyr tillatt', id: 'petsAllowed' },
    { name: 'Røyking tillatt', id: 'smokingAllowed' },
];

export const HouseRulesFilter = ({ filters, onFilterChanged }: FilterProps) => {
    const handleChange = (checked: boolean, id: string) => {
        const tempHouseRules = filters.house_rules || [];
        const tempList = Array.isArray(tempHouseRules) ? tempHouseRules : [tempHouseRules];
        const newFilters = checked ? [...tempList, id] : tempList.filter((item) => item !== id);

        onFilterChanged({ house_rules: newFilters });
    };

    return (
        <>
            {houseRulesList.map(({ name, id }) => (
                <div className="input-toggle" key={id}>
                    <Toggle
                        type="checkbox"
                        label={name}
                        checked={filters.house_rules?.includes(id)}
                        onChange={(checked: boolean) => handleChange(checked, id)}
                    />
                </div>
            ))}
        </>
    );
};
